module.exports = __webpack_public_path__ + "92108366444a107a91e95b64ecf1412d.svg";